import {twMerge} from 'tailwind-merge';
import BaseButton from '../BaseButton';
import Checkbox from '../Checkbox';

type Props = {
  brandStyle: BrandStyle;
  value: boolean;
  setValue: (value: boolean) => void;
  children: React.ReactNode;
  autoFocus?: boolean;
  className?: string;
};

const BigCheckButton = ({brandStyle, value, setValue, children, autoFocus, className}: Props) => {
  return (
    <BaseButton
      autoFocus={autoFocus}
      onClick={() => setValue(!value)}
      className={twMerge(
        'h-auto bg-white w-full max-w-[520px] py-4 text-left gap-4 font-normal text-base/snug [&_a]:underline max-[500px]:text-tiny max-[500px]:px-4',
        className
      )}
      type="button"
    >
      <Checkbox brandStyle={brandStyle} value={value} size={32} />
      {children}
    </BaseButton>
  );
};

export default BigCheckButton;
